import axios from 'axios';

export const GET_PARTNERS_URL = '/partners/getPartnersRegistrationData';

export const GET_PARTNERS_OPTIONS_URL = 'partners/getPartnersList';

export const GET_PARTNERS_EXCEL_URL = '/partners/getPartnersRegistrationDataForExcel';

export const CREATE_PARTNER = "/partners/createPartner";


export function findPartners(queryParams, cancellationHandlers) {
  return axios.get(GET_PARTNERS_URL, {params: queryParams, ...cancellationHandlers});
}

export function getPartnersOptions() {
  return axios.get(GET_PARTNERS_OPTIONS_URL);
}

export function getPartnersFile(queryParams) {
  return axios.get(GET_PARTNERS_EXCEL_URL, {params: queryParams});
}

export function createPartner(data) {
  return axios.post(CREATE_PARTNER, data);
}